import { useState } from "react";
import { api } from "../lib/api";
import { EnvelopeSimple, CheckCircle } from "@phosphor-icons/react";

export default function NewsletterSignup({ source = "landing", theme = "light" }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | ok | error
  const dark = theme === "dark";

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return;
    setState("loading");
    try {
      await api.post("/newsletter/subscribe", { email, source });
      setState("ok");
      setEmail("");
    } catch {
      setState("error");
    }
  };

  return (
    <form onSubmit={submit} className="w-full" data-testid="newsletter-form">
      <div className={`flex items-stretch border ${dark ? "border-paper/30 bg-transparent" : "border-black/15 bg-paper"}`}>
        <div className={`flex items-center pl-3 ${dark ? "text-paper/60" : "text-ink2"}`}>
          <EnvelopeSimple size={16} />
        </div>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@work.com"
          className={`flex-1 px-3 py-3 bg-transparent focus:outline-none text-sm ${dark ? "text-paper placeholder-paper/50" : "text-ink"}`}
          required
          data-testid="newsletter-email"
        />
        <button
          type="submit"
          disabled={state === "loading" || state === "ok"}
          className="px-4 bg-ikb text-paper text-sm font-semibold hover:bg-coral transition-colors disabled:opacity-70 flex items-center gap-2"
          data-testid="newsletter-submit"
        >
          {state === "ok" ? (<><CheckCircle weight="fill" size={14} /> Subscribed</>) : state === "loading" ? "…" : "Subscribe"}
        </button>
      </div>
      {state === "ok" && <div className={`text-xs mt-2 ${dark ? "text-mint" : "text-pos"} font-mono-num`}>✓ You'll get the weekly StockProfit Life brief.</div>}
      {state === "error" && <div className={`text-xs mt-2 ${dark ? "text-coral" : "text-neg"} font-mono-num`}>Something went wrong. Try again.</div>}
    </form>
  );
}
